export default "/images/hiver.svg?104be08e813248dbb70a509e33e9ca1e";